import {createContext, type MutableRefObject} from "react";
import type {QCProblemTag} from "../models/constants/qcProblemTags.ts";

export interface PreviewQCPlayer {
  currentTime: (seconds?: number | string) => number | undefined;
  pause: () => void;
  isDisposed?: () => boolean;
}

export interface QCNoteRow {
  id: string;
  timecode: number;
  timecodeLabel: string;
  text: string;
  problemTag: QCProblemTag | null;
  savedText?: string;
  savedProblemTag?: QCProblemTag | null;
  saved: boolean;
  saving: boolean;
  createdBy?: string;
  createdAt?: string;
}

export interface PreviewQCContextValue {
  isPreviewSessionActive: boolean;
  setPreviewSessionActive: (active: boolean) => void;
  setCurrentTime: (time: number) => void;
  getCurrentTime: () => number;
  playerRef: MutableRefObject<PreviewQCPlayer | null>;
  sourceLanguageCode: string;
  translationLanguages: string[];
  activeTranslationLanguage: string | null;
  selectedLanguageCode: string;
  setProjectLanguages: (sourceLanguage: string, translationLanguages: string[]) => void;
  openTranslationLanguage: (languageCode: string) => void;
  closeTranslationLanguage: () => void;
  notesLoading: boolean;
  notesError: string | null;
  notesEmpty: boolean;
  loadQCNotes: (projectId: string) => Promise<void>;
  getNotes: (languageCode: string) => QCNoteRow[];
  addNoteRow: (languageCode: string) => string;
  updateNoteText: (languageCode: string, id: string, text: string) => void;
  setNoteProblemTag: (languageCode: string, id: string, tag: QCProblemTag | null) => void;
  saveNote: (languageCode: string, id: string) => Promise<void>;
  deleteNote: (languageCode: string, id: string) => Promise<void>;
  seekToNoteTimecode: (timecode: number) => void;
  resetSession: () => void;
}

export const previewQCContext = createContext<PreviewQCContextValue | null>(null);
